import { render, staticRenderFns } from "./ButtonGroupSize.vue?vue&type=template&id=5c009038&"
import script from "./ButtonGroupSize.vue?vue&type=script&lang=js&"
export * from "./ButtonGroupSize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports